import { apiBeAuth } from "@/entities/auth";

export const DeleteFavorite = async (symbols: string) => {
  const responseBody = await apiBeAuth<BaseResponse>(`/user/watchlist/${symbols}`, {
    method: "DELETE",
  });

  return responseBody;
};
